import { HiOutlineDocumentReport } from 'react-icons/hi';
import { RiDashboardLine } from 'react-icons/ri';
import { MdOutlinePayment, MdOutlineTrackChanges } from 'react-icons/md';
import { FaFileInvoice, FaTruck } from 'react-icons/fa';
import { ImLocation2 } from 'react-icons/im';
import { IoLogOutOutline } from 'react-icons/io5';
// import { IoMdPeople } from 'react-icons/io';
import { RiTruckLine } from 'react-icons/ri';
import { Account_Statment, Booking_Detail1, Booking_Detail2, Dashboard, Invoice_Detail, PickUp_Request, PickUp_Status, Tracking, Stock_Incoming,FAST_BOOKING,Booking, Transaction,CREDIT_BOOKING } from 'mmbclient/Common/CommonVariable';

export const SidebarData = [
  {
    title: Dashboard,
    navName:"Dashboard",
    pageName : "Dashboard",
    path: '/dashboard',
    icon: <RiDashboardLine />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-speedometer",
    component: null,
    allowedFor: ["MMB", "MMB_LIVE"]  // both users
  },
  // {
  //   title: 'Booking',
  //   path: '/booking',
  //   icon: <HiOutlineDatabase />,
  //   cName: 'nav-text',
  //   visible: true,
  //   iconClass: "bi bi-file-bar-graph",
  //   component: null,
  // },
  // {
  //   title: 'Online Booking Search',
  //   path: '/online-booking-search',
  //   icon: <HiOutlineDocumentReport />,
  //   cName: 'nav-text',
  //   visible: true
  // },
  {
    title: Booking_Detail1,
    navName:"Booking Detail",
    pageName : "Booking Detail",
    path: '/consignment-detail',
    icon: <HiOutlineDocumentReport />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-search",
    component: null,
    allowedFor: ["MMB", "MMB_LIVE"]  // both users
  },
  {
    title: Booking_Detail2,
    navName:"Booking Detail",
    pageName : "Booking Detail",
    path: '/consignment-detail',
    icon: <HiOutlineDocumentReport />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-search",
    component: null,
    allowedFor: ["MMB", "MMB_LIVE"]  // both users
  },
  {
    title: Invoice_Detail,
    navName:"Invoice Detail",
    pageName : "Invoice Detail",
    path: '/invoice-detail',
    icon: <FaFileInvoice />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-receipt",
    component: null,
    allowedFor: ["MMB", "MMB_LIVE"]  // both users
  },
  {
    title: Account_Statment,
    navName:"Account Statment",
    pageName : "Account Statment",
    path: '/account-statement',
    icon: <MdOutlinePayment />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-credit-card-2-front",
    component: null,
    allowedFor: ["MMB", "MMB_LIVE"]  // both users
  },
  {
    title: Tracking,
    navName:"Tracking",
    pageName : "Tracking",
    path: '/tracking',
    icon: <MdOutlineTrackChanges />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-bullseye",
    component: null,
    allowedFor: ["MMB", "MMB_LIVE"]  // both users
  },
  {
    title: PickUp_Request,
    navName:"PickUp Request",
    pageName : "PickUp Request",
    path: '/credit-pickup-request',
    icon: <RiTruckLine />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-arrow-down-up",
    component: null,
    allowedFor: []  // both users
  },
  // {
  //   title: PickUp_Status,
  //   pageName : "Stock", // change name from pickup status to stock
  //   path: '/credit-pickup-status',
  //   icon: <RiTruckLine />,
  //   cName: 'nav-text',
  //   visible: true,
  //   iconClass: "bi bi-file-arrow-down",
  //   component: null,
  //   allowedFor: [],  // both users
  //   subNav : [
  //               {
  //                 title: Stock_Incoming,
  //                 pageName:"Stock Available",
  //                 path:"stock-incoming",
  //                 cName: "nav_text",
  //                 visible: true,
  //                 component: null,
  //                 allowedFor: ["MMB","MMB_LIVE"] // MMB users
  //               }
  //             ]
  // },

    {
    title: Stock_Incoming,
    navName:"Stock",
    pageName : "Stock Available", // change name from pickup status to stock
    path: 'stock-incoming',
    icon: <RiTruckLine />,
    cName: 'nav-text',
    visible: true,
    iconClass: "bi bi-file-arrow-down",
    component: null,
    allowedFor: ["MMB","MMB_LIVE"],
  },
  {
    title:Transaction,
    navName:"Booking",
    pageName:"Fast Booking",
    path:"/fast-booking",
    icon:<FaTruck/>,
    cName:"nav-text",
    visible:true,
    iconClass:"bi bi-calendar-check",
    component:"null",
    allowedFor: ["MMB_LIVE"],  // MMB_LIVE users
  },
  {
    title:Transaction,
    navName:"Booking",
    pageName:"Credit Booking",
    path:"credit-booking",
    icon:<FaTruck/>,
    cName:"nav-text",
    visible:true,
    iconClass:"bi bi-calendar-check",
    component:"null",
    allowedFor: ["MMB"],  // MMB_LIVE users
  }
];

export const TrackingIcon = [
  {
    title: Tracking,
    navName:"Tracking",
    pageName : "Tracking",
    path: '＃',
    // path: '/mmbclient/tracking',
    icon: <ImLocation2 />,
    cName: 'nav-text',
    allowedFor: ["MMB", "MMB_LIVE"]  // both users
  }
];


export const LogOut = [
  {
    title: 'Log Out',
    // logOut: 'function() { store.setLogin("out"); }',
    icon: <IoLogOutOutline />,
    cName: 'nav-text'
  }
];
